angular.module('unica_check.check_controllers')

.controller('CheckInvitationController', function(
	CONFIG,
	$rootScope, $scope, $state, $stateParams,
	$ocLazyLoad, $injector,
	toast,
	CheckService, InvitationListListService
) {
	$scope.checkedIns = [];
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	// LAZY LOAD
	$rootScope.showLoader();
	$ocLazyLoad
		.load([ '/js/app/angular-scanner.packed.js' ])
		.then(function() {
			$rootScope.hideLoader();

			setupScanner();
		});

	function setupScanner()
	{
		var scanner = new Instascan.Scanner({ video: document.getElementById('check_video'), scanPeriod: 5 });

		scanner.addListener('scan', function (hash) {
			checkInByHash(hash);
		});

		$scope.isRearCamera = false;

		Instascan.Camera
			.getCameras()
			.then(function (cameras) {
				if (cameras.length > 0) {
					if ( cameras.length > 1 ) {
						if (cameras[1].name.toLowerCase().indexOf('back') != -1 ) {
							scanner.start(cameras[1]);
							$scope.isRearCamera = true;
							$scope.$apply();
						}
					} else {
						scanner.start(cameras[0]);
					}
				} else {
					console.error('No cameras found.');
				}
			})
			.catch(function (e) {
				console.error(e);
			});
	}

	function checkInByHash(hash) {
		$scope.showLoader();

		CheckService
			.checkInInvitation(hash)
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					if ( data.already_checked_in ) {
						var text = '<strong>' + data.invitation.user.first_name + ' ' + data.invitation.user.last_name + '</strong> ha già fatto check in.',
							cssClass = 'alert-warning';
					} else {
						var text = '<strong>' + data.invitation.user.first_name + ' ' + data.invitation.user.last_name + '</strong> checked in.',
							cssClass = 'alert-success';
					}

					toast({
						duration  : 500000,
						message   : text,
						position: 'center',
						container: '.alert_check_container',
						className : cssClass
					});

				} else {
					$scope.hideLoader();
					$rootScope.manageError(data);
				}
			});
	};

	$scope.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

	$scope.openQRCamera = function() {
		node = document.getElementById('camera_ios');

		var reader = new FileReader();
		reader.onload = function() {
			node.value = "";
			qrcode.callback = function(res) {
				if(res instanceof Error) {
					alert("No QR code found. Please make sure the QR code is within the camera's frame and try again.");
				} else {
					checkInByHash(res);
					//node.parentNode.previousElementSibling.value = res;
				}
			};
			qrcode.decode(reader.result);
		};
		reader.readAsDataURL(node.files[0]);
	};


	$scope.invitationsLists = [];
	$scope.loadInvitationsLists = function() {
		$scope.showLoader();
		InvitationListListService
			.fullList( $scope.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					angular.forEach(data, function(il, key) {
						if ( il.stage ) {
							data[key].stage.from_date = moment.unix( il.stage.from_date ).toDate();
							data[key].stage.to_date   = moment.unix( il.stage.to_date ).toDate();
						}
					});

					$scope.invitationsLists = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.loadInvitationsLists();

});
